import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import moment from 'moment';
import FileUpload from '../../common/components/inputs/FileUpload';
import {
  QuoteInfoContainerAfterSale,
  WaitingForPaymentQuoteInfoAfterSale,
} from '../../common/components/redesignComponents/Purchase/PaymentStatusAfterSale.styles';
import {
  generalAlertError,
  generalAlertSuccessToast,
} from '../../common/utils/alerts';
import {
  apiAfterSaleOptionalDocumentMethodManualUpload,
  apiDownloadAfterSaleOptionalDocument,
} from '../../services/axios-client/axeCommons';
import PageLoading from '../../common/components/elements/PageLoading';
import ErrorComponent from '../../common/components/ErrorComponent';
import AfterSaleToSignDocumentComponent from '../../common/components/redesignComponents/Cards/AfterSaleToSignDocumentComponent';
import {
  getSuspension,
  resetSuspension,
} from '../../features/afterSale/afterSaleActions';
import managementAxe from '../../services/axios-client/managementServisAxeClient';
import AfterSaleDocumentComponent from '../../common/components/redesignComponents/Cards/AfterSaleDocumentComponent';
import { after_sale_purchase_statues } from '../../common/constants';

function SuspensionPage() {
  const navigate = useNavigate();
  const { suspensionId } = useParams();

  const state = useSelector((store) => store.afterSale.suspension_page);
  const { loading, suspension, error } = state;

  // const {
  //   setState,
  //   state: { run, showBeacon },
  // } = useTourContext();

  // useEffect(() => {
  //   if (localStorage.getItem('singleCancellation') === 'done') {
  //     setState({ run: false });
  //   } else {
  //     setTimeout(() => {
  //       setState({ run: true });
  //     }, 1500);
  //   }
  // }, [localStorage.getItem('singleCancellation')]);

  // const fireNewQuoteTour = () => {
  //   localStorage.removeItem('singleCancellation');
  //   setState({ run: true, tourActive: true });
  // };

  useEffect(() => {
    getSuspension(suspensionId);
    return () => {
      resetSuspension();
    };
  }, []);

  const downloadDocument = async (suspensionRequestDocumentId) => {
    const response = await managementAxe.get(
      `/broker/after-sale/suspension/documents/${suspensionRequestDocumentId}/download`,
    );
    const alink = document.createElement('a');
    alink.target = '_blank';
    alink.href = response.data.data.contents;
    alink.download = response.data.data.filename;
    alink.click();
  };

  const downloadOptionalDocument = async (documentId) => {
    const response = await apiDownloadAfterSaleOptionalDocument(documentId);
    const alink = document.createElement('a');
    alink.target = '_blank';
    alink.href = response.data.data.contents;
    alink.download = response.data.data.filename;
    alink.click();
  };

  const showAfterSaleUploadedDocuments = () => {
    const docs = [...suspension.after_sale_optional_documents];

    return (
      <div className="ps-3 mt-3">
        {docs.length === 0 && <p>Nessun documento caricato.</p>}

        {docs.map((doc) => (
          <AfterSaleToSignDocumentComponent
            key={doc.id}
            document={doc}
            downloadDocument={downloadOptionalDocument}
          />
        ))}
      </div>
    );
  };

  const uploadSignedOptionalDocument = async (documentId, file) => {
    const uploadedFile = file[0];
    const reader = new FileReader();
    reader.readAsDataURL(uploadedFile);
    if (uploadedFile.type !== 'application/pdf') {
      generalAlertError('Formato di file errato. Il file deve essere in .pdf');
      return;
    }
    reader.onload = () => {
      apiAfterSaleOptionalDocumentMethodManualUpload(documentId, {
        document: reader.result.replace('data:application/pdf;base64,', ''),
      }).then(() => {
        getSuspension(suspensionId);
        generalAlertSuccessToast('File caricato');
      });
    };
  };

  if (loading) {
    return <PageLoading />;
  }

  if (error !== null) {
    return <ErrorComponent error={error} />;
  }

  if (suspension && suspension.status !== 5) {
    navigate(`/after-sale/purchase/suspension/${suspension.id}`);
  }

  return (
    <>
      {/* <Joyride
      steps={cancellationSteps}
      continuous
      showBeacon={showBeacon}
      locale={{
        back: 'Indietro',
        close: 'Chiudi',
        last: 'Fine',
        next: 'Prossima',
        open: 'Apri il modale',
        restart: 'Riavvia il tour ',
        skip: 'Salta',
      }}
      styles={{
        options: joyrideOptions,
        buttonNext: {
          backgroundColor: '#00a651',
          outline: 'none',
        },
        buttonBack: {
          color: '#00a651',
          outline: 'none',
        },
        beaconInner: {
          backgroundColor: '#00a651',
        },
        beaconOuter: {
          borderColor: '#00a651',
          backgroundColor: 'rgba(68 , 154 , 71, 0.4)',
        },
        buttonSkip: {
          outline: 'none',
        },
        buttonClose: {
          outline: 'none',
        },
      }}
      run={run}
      callback={(data) => handleCallbackCancellation(data, cancellationSteps, setState)}
      showSkipButton
      showProgress
    /> */}
      <div className="d-flex gap-2">
        <div
          className="btn btn-success btn-sm text-white px-4 mb-4"
          onClick={() => navigate('/cancellations')}
        >
          Torna indietro
        </div>
        {/* {localStorage.getItem('singleCancellation') === 'done' && (
        <div style={{ cursor: 'pointer' }} onClick={() => fireNewQuoteTour()}>
          <button className="btn btn-success btn-sm text-white px-4 mb-4">Tutorial</button>
        </div>
      )} */}
      </div>
      <div className="row">
        <div className="col-12 col-md-6 mb-3">
          <WaitingForPaymentQuoteInfoAfterSale>
            <QuoteInfoContainerAfterSale>
              <h3 className="ps-3">
                <strong>Sospensione #</strong>
                {suspension.id}
              </h3>
              <div className="single-suspension-one ps-3 mb-4 mt-0">
                {suspension.quotation.insurance_request.customer && (
                  <div>
                    <p className="my-1">
                      <strong> Cliente:</strong>
                      {' '}
                      <span>
                        {suspension.quotation.insurance_request.customer
                          .gender !== 'G'
                          ? `${suspension.quotation.insurance_request.customer.name} ${suspension.quotation.insurance_request.customer.surname}`
                          : suspension.quotation.insurance_request.customer
                            .business_name}
                      </span>
                    </p>
                    <p className="my-1">
                      <strong> Stato:</strong>
                      {' '}
                      <div className="badge bg-success">
                        {
                          after_sale_purchase_statues.find(
                            (status) => status.id === suspension.status,
                          )?.name
                        }
                      </div>
                    </p>
                  </div>
                )}
                <div>
                  <p className="my-1">
                    <strong>Data Sospensione:</strong>
                    {' '}
                    <span>
                      {new Date(suspension.suspension_date).toLocaleDateString(
                        'it-IT',
                        { day: '2-digit', month: '2-digit', year: 'numeric' },
                      )}
                    </span>
                  </p>
                </div>
                <div>
                  <p className="my-1">
                    <strong>Data Riattivazione:</strong>
                    {' '}
                    <span>
                      {new Date(
                        suspension.riactivation_date,
                      ).toLocaleDateString('it-IT', {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric',
                      })}
                    </span>
                  </p>
                </div>
                {suspension.quotation.insurance_request.product && (
                  <div>
                    <p className="my-1">
                      <strong> Prodotto:</strong>
                      {' '}
                      <span>
                        {suspension.quotation.insurance_request.product.name}
                      </span>
                    </p>
                  </div>
                )}
                {suspension.quotation.company && (
                  <div>
                    <p className="my-1">
                      <strong> Compagnia:</strong>
                      {' '}
                      <span>{suspension.quotation.company.name}</span>
                    </p>
                  </div>
                )}
                {suspension.quotation.insurance_request.vehicle && (
                  <div>
                    <p className="my-1">
                      <strong> Targa:</strong>
                      {' '}
                      <span>
                        {
                          suspension.quotation.insurance_request.vehicle
                            .vehicle_plate
                        }
                      </span>
                    </p>
                  </div>
                )}

                {(suspension.quotation.insurance_request.vehicle?.previousCompany?.label
                  ?? suspension.quotation.insurance_request.vehicle?.previous_company?.label
                  ?? suspension.quotation.insurance_request.vehicle?.previous_company_label) && (
                  <div>
                    <p className="my-1">
                      <strong> Compagnia assicurativa attuale:</strong>
                      {' '}
                      <span>
                        {suspension.quotation.insurance_request.vehicle?.previousCompany?.label
                          ?? suspension.quotation.insurance_request.vehicle?.previous_company?.label
                          ?? suspension.quotation.insurance_request.vehicle?.previous_company_label}
                      </span>
                    </p>
                  </div>
                )}

                {(suspension.quotation.insurance_request.moto?.previousCompany?.label
                  ?? suspension.quotation.insurance_request.moto?.previous_company?.label
                  ?? suspension.quotation.insurance_request.moto?.previous_company_label) && (
                  <div>
                    <p className="my-1">
                      <strong> Compagnia assicurativa attuale:</strong>
                      {' '}
                      <span>
                        {suspension.quotation.insurance_request.moto?.previousCompany?.label
                          ?? suspension.quotation.insurance_request.moto?.previous_company?.label
                          ?? suspension.quotation.insurance_request.moto?.previous_company_label}
                      </span>
                    </p>
                  </div>
                )}

                {/* <div>
                  <p className="my-1">
                    <strong>
                      Data:
                    </strong>
                    {' '}
                    <span>
                      {new Date(suspension.date).toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric' })}
                    </span>
                  </p>
                </div> */}
                <div>
                  <p className="my-1">
                    <strong>Creato:</strong>
                    {' '}
                    <span>
                      {new Date(suspension.created_at).toLocaleDateString(
                        'it-IT',
                        { day: '2-digit', month: '2-digit', year: 'numeric' },
                      )}
                    </span>
                  </p>
                </div>
                <div>
                  <p className="my-1">
                    <b>Note:</b>
                  </p>
                  <p className="m-0">{suspension.note}</p>
                </div>
              </div>
            </QuoteInfoContainerAfterSale>
          </WaitingForPaymentQuoteInfoAfterSale>
        </div>
        <div className="col-12 col-md-6">
          {suspension.after_sale_payment_request
            && suspension.after_sale_payment_request.is_paid === 1 && (
              <div className="row">
                <div className="col-12 mt-2 mt-xxl-0 payment-information mb-3">
                  <WaitingForPaymentQuoteInfoAfterSale>
                    <QuoteInfoContainerAfterSale>
                      <div>
                        <h3 className="ps-3 mb-4 mt-0">
                          Detagli
                          {' '}
                          <b>Pagamento</b>
                        </h3>
                      </div>
                      <div className="ps-3 mb-4 mt-0">
                        <p className="my-1">
                          <strong> Premio:</strong>
                          {' '}
                          <span>
                            {parseFloat(
                              suspension.after_sale_payment_request.amount,
                            )}
                            {' '}
                            &euro;
                          </span>
                        </p>
                        <p className="my-1">
                          <strong>Stato Pagamento:</strong>
                          {' '}
                          <span>
                            {suspension.after_sale_payment_request.is_paid === 1
                              ? 'Pagato'
                              : suspension.after_sale_payment_request
                                .is_paid === 0
                                ? 'Pagamento Non valido'
                                : 'In Attesa Pagamento'}
                          </span>
                        </p>
                        <p className="my-1">
                          <strong>Data Richiesta:</strong>
                          {' '}
                          <span>
                            {moment(
                              suspension.after_sale_payment_request.created_at,
                            ).format('DD-MM-YYYY')}
                          </span>
                        </p>
                        <p className="my-1">
                          <strong>Informazione Pagamento:</strong>
                          {' '}
                          <span>
                            {
                              suspension.after_sale_payment_request
                                .payment_description
                            }
                          </span>
                        </p>
                      </div>
                    </QuoteInfoContainerAfterSale>
                  </WaitingForPaymentQuoteInfoAfterSale>
                </div>
                <div className="col-12 mt-2 mt-xxl-0 payment-information mb-3">
                  <WaitingForPaymentQuoteInfoAfterSale>
                    <QuoteInfoContainerAfterSale>
                      <h3 className="ps-3 mb-4 mt-0">Polizza</h3>
                      <div className="ps-3">
                        {suspension.documents.find(
                          (d) => d.after_sale_document_type_id === 3,
                        ) === undefined && (
                        <p className="mt-3">Nessun documento caricato.</p>
                        )}
                        {suspension.documents
                          .filter((d) => d.after_sale_document_type_id === 3)
                          .map((document) => (
                            <AfterSaleDocumentComponent
                              key={document.id}
                              document={document}
                              downloadDocument={downloadDocument}
                            />
                          ))}
                      </div>
                    </QuoteInfoContainerAfterSale>
                  </WaitingForPaymentQuoteInfoAfterSale>
                </div>
              </div>
          )}
          {suspension.requires_payment === 0 && (
            <div className="row">
              <div className="col-12 mt-2 mt-xxl-0 payment-information mb-3">
                <WaitingForPaymentQuoteInfoAfterSale>
                  <QuoteInfoContainerAfterSale>
                    <div>
                      <h3 className="ps-3 mb-4 mt-0">
                        Detagli
                        {' '}
                        <b>Pagamento</b>
                      </h3>
                    </div>
                    <div className="ps-3 mb-4 mt-0">
                      <div className="alert alert-info w-75">
                        Nessun pagamento richiesto per questa sostituzione.
                      </div>
                    </div>
                  </QuoteInfoContainerAfterSale>
                </WaitingForPaymentQuoteInfoAfterSale>
              </div>
              <div className="col-12 mt-2 mt-xxl-0 payment-information mb-3">
                <WaitingForPaymentQuoteInfoAfterSale>
                  <QuoteInfoContainerAfterSale>
                    <h3 className="ps-3 mb-4 mt-0">Polizza</h3>
                    <div className="ps-3">
                      {suspension.documents.find(
                        (d) => d.after_sale_document_type_id === 3,
                      ) === undefined && (
                      <p className="mt-3">Nessun documento caricato.</p>
                      )}
                      {suspension.documents
                        .filter((d) => d.after_sale_document_type_id === 3)
                        .map((document) => (
                          <AfterSaleDocumentComponent
                            key={document.id}
                            document={document}
                            downloadDocument={downloadDocument}
                          />
                        ))}
                    </div>
                  </QuoteInfoContainerAfterSale>
                </WaitingForPaymentQuoteInfoAfterSale>
              </div>
            </div>
          )}
        </div>
        <div className="col-12 col-md-6 mt-3 mt-md-0">
          <WaitingForPaymentQuoteInfoAfterSale>
            <QuoteInfoContainerAfterSale>
              <div className="single-suspension-two">
                <h3 className="ps-3">
                  <strong>Documenti</strong>
                </h3>
                <div className="ps-3 mt-3">
                  {suspension.documents.length !== 0 ? (
                    suspension.documents.map((document) => (
                      // <div key={document.id} className="d-flex border border-success rounded py-3 m-1" style={{ maxWidth: 600 }}>
                      //   <div className="d-flex align-items-center justify-content-start ms-3">
                      //     <img src={pdfIMG} className="img-fluid me-2" width="30" alt="PDF" />
                      //     <h5 className="h6 mb-0">
                      //       {document.original_filename}
                      //     </h5>
                      //   </div>
                      //   <div className="d-flex align-items-center justify-content-center ms-auto">
                      //     <button
                      //       className="doc-btn border-0 bg-transparent"
                      //       onClick={() => downloadDocument(document.id)}
                      //     >
                      //       <img src={downloadIMG} width="30" alt="" />
                      //     </button>
                      //   </div>
                      // </div>
                      <AfterSaleDocumentComponent
                        key={document.id}
                        document={document}
                        downloadDocument={downloadDocument}
                      />
                    ))
                  ) : (
                    <p>Nessun Documento Trovato</p>
                  )}
                </div>
              </div>
            </QuoteInfoContainerAfterSale>
          </WaitingForPaymentQuoteInfoAfterSale>
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-12 col-xl-6">
          <WaitingForPaymentQuoteInfoAfterSale>
            <QuoteInfoContainerAfterSale>
              <h3 className="ps-3">
                <strong>Documenti Da Firmare</strong>
              </h3>
              <div>{showAfterSaleUploadedDocuments()}</div>
              <div className="col-12 mt-3 mt-xl-2 d-flex single-suspension-three">
                <div className="col-6 mt-3 mt-xl-0">
                  <div className="card ps-3">
                    <div className="card-body px-0">
                      {suspension.after_sale_optional_documents
                        .filter(
                          (document) => document.signable_document === 1
                            && document.is_uploaded_valid === 1
                            && ((document.is_signed_valid === 0
                              && document.signed_document_filename !== null)
                              || (document.is_signed_valid === null
                                && document.signed_document_filename === null)),
                        )
                        .map((file) => (
                          <div className="mb-3">
                            <FileUpload
                              key={file.id}
                              multiple={false}
                              label={`CARICA ${file.optional_document_name.toUpperCase()}`}
                              handleFile={(f) => uploadSignedOptionalDocument(file.id, f)}
                            />
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              </div>
            </QuoteInfoContainerAfterSale>
          </WaitingForPaymentQuoteInfoAfterSale>
        </div>
      </div>
    </>
  );
}

export default SuspensionPage;
